import { getCurrentTimestamp } from '../../utils/DateUtils'
import {
  APP_LOADED,
  HIDE_LOADER,
  SHOW_LOADER,
  SHOW_NUDGES,
  HIDE_NUDGES,
  TOGGLE_NUDGE,
  APP_INITIALIZATION,
  MUSIC_STATUS_RECEIVED,
  SOUND_STATUS_RECEIVED,
  SET_LOCATION_PERMISSION_STATUS,
  SHOW_LOCATION_MODAL,
  HIDE_LOCATION_MODAL,
  NOTIFICATION_COUNT_UPDATE,
  USER_LOGOUT,
  DISMISS_SPLASH_SCREEN,
  HERO_VIDEO_PLAYED_ONCE,
  HIDE_FORCE_UPDATE,
  SET_SERIAL_NUMBER,
  SET_PAYOUT_MODES,
  SET_FIRST_DEPOSIT_MODAL,
  SET_TOKEN,
  DISCOUNTED_FEE_DATA,
  GST_MULTIPLIER_FACTOR,
  DISCOUNTED_FEE_CONFIG,
  SET_RG_BLOCK,
  SHOW_MODALS,
  HIDE_MODALS,
  UPDATE_REFERRAL_PROGRESS_CARDS,
  SET_DASHBOARD_DYNAMIC_DATA,
  CHANGE_APP_STATE,
  ACADEMY_CONFIG_DATA,
  IS_AUTH_API_RESPONSE_STATUS,
  SHOW_GOOGLE_LOGIN_MODAL,
  HIDE_GOOGLE_LOGIN_MODAL
} from '../reduxConstants'
// import { destroySocket } from 'classes/socket'
import isEmpty from 'lodash/isEmpty'

// import { LANGUAGE_CHANGED } from 'screens/login/Constants'
// import { getCurrentTimestamp } from 'utils/ZupeeClock'

const initialState = {
  preSignupConfig: null,
  loader: false,
  isAppLoaded: false,
  showSplashScreen: true,
  isHeroVideoPlayedOnce: false,
  loaderText: '',
  loaderBackgroundImage: true,
  soundStatus: false,
  musicStatus: false,
  language: null,
  token: null,
  verifyOtpErrorMsg: '',
  showNudges: false,
  showModals: false,
  nudgesData: null,
  serialNumber: null,
  locationPermission: false,
  locationPermissionStatus: 'notAsked',
  locationModal: false,
  locationErrorObject: null,
  updatedNotificationCount: 0,
  showForceUpdate: true,
  showFirstDepostModal: false,
  isRGBlocked: false,
  dashboardDynamicData: null,
  isAuthApiResponseStatus: false,
  showGoogleLoginModal: false
}

// const DashboardDynamicData = {
//   registeredTournaments: [],
//   referralProgressCards: null,
//   predictWinV2: {
//     isEnable: true,
//     contestId: 'Match55',
//     contestStartTime: 1712927760000,
//     contestEndTime: 1712928720000,
//     rewardSegment: 'default',
//     liveContestRefreshDelaySec: 90
//   }
// }

export default function appReducer(state = initialState, action) {
  switch (action.type) {
    case DISMISS_SPLASH_SCREEN: {
      return { ...state, showSplashScreen: false }
    }

    case HERO_VIDEO_PLAYED_ONCE: {
      return { ...state, isHeroVideoPlayedOnce: true }
    }

    // case LANGUAGE_CHANGED: {
    //   destroySocket('language changed')
    //   const { preSignupConfig, isAppLoaded } = action
    //   return { ...state, preSignupConfig, isAppLoaded }
    // }

    case APP_LOADED: {
      const { soundStatus, isFirstLaunch, preSignupConfig } = action
      return {
        ...state,
        isAppLoaded: true,
        soundStatus,
        isFirstLaunch,
        preSignupConfig
      }
    }

    case APP_INITIALIZATION: {
      const { soundStatus = true, musicStatus = false } = action
      return { ...state, soundStatus, musicStatus }
    }

    case NOTIFICATION_COUNT_UPDATE: {
      return {
        ...state,
        updatedNotificationCount: action.notificationCount
      }
    }

    case USER_LOGOUT: {
      const { preSignupConfig, serialNumber } = state
      return {
        ...initialState,
        serialNumber,
        preSignupConfig,
        isAppLoaded: true,
        showSplashScreen: false,
        isHeroVideoPlayedOnce: false,
        isFirstLaunch: false
      }
    }

    case SHOW_LOADER:
      return {
        ...state,
        loader: true,
        loaderText: action.loaderText,
        loaderBackgroundImage: action.loaderBackgroundImage
      }

    case SHOW_NUDGES:
      return {
        ...state,
        showNudges: true,
        nudgesData: { ...action.data, type: action.bottomsheet_type }
      }

    case HIDE_NUDGES:
      return { ...state, showNudges: false, nudgesData: {} }

    case CHANGE_APP_STATE:
      return { ...state, appState: action.appState }

    case SHOW_MODALS:
      return { ...state, showModals: true, data: action.data }

    case HIDE_MODALS:
      return { ...state, showModals: false, data: {} }

    case TOGGLE_NUDGE:
      return { ...state, showNudges: !action.shouldHide && !isEmpty(state.nudgesData) }

    case HIDE_LOADER:
      return {
        ...state,
        loader: false,
        loaderText: '',
        loaderBackgroundImage: true
      }

    case SOUND_STATUS_RECEIVED:
      return { ...state, soundStatus: action.soundStatus }

    case MUSIC_STATUS_RECEIVED:
      return { ...state, musicStatus: action.musicStatus }

    case SET_LOCATION_PERMISSION_STATUS:
      return {
        ...state,
        locationPermissionStatus: action.locationPermissionStatus
      }

    case SHOW_LOCATION_MODAL:
      return {
        ...state,
        locationModal: true,
        locationErrorObject: action.locationErrorObject
      }

    case HIDE_LOCATION_MODAL:
      return { ...state, locationModal: false }

    case HIDE_FORCE_UPDATE:
      return { ...state, showForceUpdate: false }
    case SET_SERIAL_NUMBER: {
      return { ...state, serialNumber: action.serialNumber }
    }
    case SET_PAYOUT_MODES:
      return { ...state, payoutModes: { ...(action.payoutModes || {}), queryTime: getCurrentTimestamp() } }
    case SET_FIRST_DEPOSIT_MODAL:
      return { ...state, showFirstDepostModal: !state.showFirstDepostModal }
    case SET_TOKEN:
      return { ...state, token: action.token }
    case DISCOUNTED_FEE_DATA:
      return {
        ...state,
        discountedEFData: action.discountedEFData
      }
    case DISCOUNTED_FEE_CONFIG:
      return {
        ...state,
        isDEFEnabled: action.isDEFEnabled,
        lobbyToolTipMessage: action.lobbyToolTipMessage || state.lobbyToolTipMessage
      }
    case ACADEMY_CONFIG_DATA:
        return {
          ...state,
          academyConfig: action.academyConfig || {}
        }
    case GST_MULTIPLIER_FACTOR:
      return {
        ...state,
        gstMultiplierFactor: action.gstMultiplierFactor,
        gstMsg: action?.gstMsg
      }
    case SET_RG_BLOCK:
      return {
        ...state,
        isRGBlocked: action.isRGBlocked
      }

    case SET_DASHBOARD_DYNAMIC_DATA:
      return {
        ...state,
        dashboardDynamicData: action.dashboardDynamicData
      }

    case UPDATE_REFERRAL_PROGRESS_CARDS:
      const dashboardDynamicData = { ...state.dashboardDynamicData, referralProgressCards: action.referralProgressCards }
      return {
        ...state,
        dashboardDynamicData
      }
    case IS_AUTH_API_RESPONSE_STATUS:
      return {
        ...state,
        isAuthApiResponseStatus: action.isAuthApiResponseStatus || false
      }
    case SHOW_GOOGLE_LOGIN_MODAL:
      return {
        ...state,
        showGoogleLoginModal: true
      }
    case HIDE_GOOGLE_LOGIN_MODAL:
      return {
        ...state,
        showGoogleLoginModal: false
      }
    default:
      return state
  }
}
